import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-concealed-damage-detail-question',
  templateUrl: './concealed-damage-detail-question.component.html',
  styleUrls: ['./concealed-damage-detail-question.component.scss']
})
export class ConcealedDamageDetailQuestionComponent implements OnInit {

  constructor(protected bsModalRef: BsModalRef,) {
  }

  ngOnInit(): void {
  }

  cancel() {
    this.bsModalRef.hide();
  }


}
